export const generateTicks = (chart: any) => {
    const ctx = chart.ctx;
    ctx.save();
    ctx.font = "bold 10px Davis Sans-Medium";
    ctx.fillStyle = "white"; // Tick color
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    const scale = chart.scales.r;
    const ticks = scale.getTicks();
    const centerX = scale.xCenter;
    const tickValues = ticks.map((t: any) => +t.value).flat();
    const centerY = scale.yCenter / 1.5;
    const maxTickValue = Math.max(...tickValues);
    const drawArea = scale.drawingArea;


    ticks.forEach((tick: any, i: number) => {
        const value = tick.value;
        if (value > 0) {
            let y = centerY - drawArea * (value / maxTickValue) + 65;
            const textWidth = ctx.measureText(value).width + 15;
            const textHeight = 20;
            const radius = 4;
            const rectX = centerX - textWidth / 2;
            const rectY = +y - textHeight / 2;

            ctx.fillStyle = "#131314";
            ctx.beginPath();
            ctx.moveTo(rectX + radius, rectY);
            ctx.lineTo(rectX + textWidth - radius, rectY);
            ctx.quadraticCurveTo(
                rectX + textWidth,
                rectY,
                rectX + textWidth,
                rectY + radius
            );
            ctx.lineTo(rectX + textWidth, rectY + textHeight - radius);
            ctx.quadraticCurveTo(
                rectX + textWidth,
                rectY + textHeight,
                rectX + textWidth - radius,
                rectY + textHeight
            );
            ctx.lineTo(rectX + radius, rectY + textHeight);
            ctx.quadraticCurveTo(
                rectX,
                rectY + textHeight,
                rectX,
                rectY + textHeight - radius
            );
            ctx.lineTo(rectX, rectY + radius);
            ctx.quadraticCurveTo(rectX, rectY, rectX + radius, rectY);
            ctx.closePath();
            ctx.fill();

            // Draw border around the rectangle
            ctx.strokeStyle = "#76777A"; // Border color
            ctx.lineWidth = 0.25; // Border width
            ctx.stroke();

            // Draw the tick value
            ctx.fillStyle = "white"; // Text fill color
            ctx.fillText(value, centerX, +y); // Fill text
        }
    });

    ctx.restore();
}
export const generatePointValue = (chart: any) => {
    const { ctx, chartArea } = chart;
    const centerX = (chartArea.left + chartArea.right) / 2;
    chart.data.datasets.forEach((dataset: any, datasetIndex: any) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        meta.data.forEach((point: any, index: any) => {
            const value = dataset.data[index];
            const { x, y } = point.tooltipPosition(true);
            const position = x < centerX ? "left" : "right";
            const xPosition = position === "left" ? x - 20 : x + 20;
            ctx.save();
            ctx.fillStyle = "white";
            ctx.font = "700 10px Davis Sans-Medium, sans-serif";
            ctx.textAlign = "center";
            ctx.fillText(value as any, xPosition, y);
            ctx.restore();
        });
    });
}

export const createGradient = (ctx: CanvasRenderingContext2D, chartArea: any) => {
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const radius = Math.min(
        (chartArea.right - chartArea.left) / 3.2,
        (chartArea.bottom - chartArea.top) / 3.2
    );

    const gradient = ctx.createRadialGradient(
        centerX,
        centerY,
        0,
        centerX,
        centerY,
        radius
    );
    // Brand-green radial glow (was a blue/purple/magenta rainbow) fading toward the edge
    gradient.addColorStop(0.4, "#96CB3940"); // 40% stop
    gradient.addColorStop(0.85, "#96CB3925"); // 85% stop
    gradient.addColorStop(1, "#96CB3910"); // 100% stop
    return gradient;
};